import * as React from "react"
import {Form, InputOnChangeData} from "semantic-ui-react"
import {isValidPassenger, passengerErrorFields} from "../model/passenger/passenger"
import {PassengerFormData} from "../model/passenger/types"
import {formatMobile, PhoneField} from "./PhoneField"

interface Props {
  passenger: PassengerFormData
  onSave: (x: PassengerFormData) => void
  onReset: (() => void) | null
  mobileRequired: boolean
}

export class PassengerForm extends React.Component<Props, {passenger: PassengerFormData}> {
  constructor(props: Props) {
    super(props)
    this.state = {passenger: props.passenger}
  }

  render() {
    const {onReset, mobileRequired} = this.props

    const {
      passenger,
      passenger: {name, mobile, phone},
    } = this.state

    const email = passenger.email || ""

    const errorFields = passengerErrorFields(passenger, mobileRequired)
    const nameError = errorFields.has("name")
    const emailError = email.length > 0 && errorFields.has("email")
    const mobileError = errorFields.has("mobile")
    const phoneError = errorFields.has("phone")

    return (
      <>
        <Form.Group>
          <Form.Field required error={nameError}>
            <label>Name</label>
            <Form.Input
              placeholder="Name"
              value={name}
              onChange={(e: any, field: InputOnChangeData) => {
                this.onPassenger({name: field.value})
              }}
            />
          </Form.Field>
          <Form.Input
            type="email"
            label="Email"
            placeholder="Email"
            error={emailError}
            value={email}
            onChange={(e: any, field: InputOnChangeData) => {
              this.onPassenger({email: field.value})
            }}
          />
        </Form.Group>
        <Form.Group>
          <PhoneField
            label="Mobile"
            phoneNumber={mobile || ""}
            required={mobileRequired}
            error={mobileError}
            onChange={(x: string) => {
              this.onPassenger({mobile: x})
            }}
          />
        </Form.Group>
        <Form.Group>
          <PhoneField
            label="Phone"
            phoneNumber={phone || ""}
            required={false}
            error={phoneError}
            onChange={(x: string) => {
              this.onPassenger({phone: x})
            }}
          />
        </Form.Group>
        <Form.Group>
          <Form.Button disabled={errorFields.size > 0} onClick={this.onSave}>
            Save
          </Form.Button>
          {onReset && <Form.Button onClick={onReset}>Reset</Form.Button>}
        </Form.Group>
      </>
    )
  }

  onSave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    const {passenger} = this.state

    if (isValidPassenger(passenger, this.props.mobileRequired)) {
      const formattedPassenger: PassengerFormData = {
        ...passenger,
        mobile: passenger.mobile ? formatMobile(passenger.mobile) : null,
        phone: passenger.phone ? formatMobile(passenger.phone) : null,
      }
      this.props.onSave(formattedPassenger)
    }
  }

  onPassenger(p: Partial<PassengerFormData>): void {
    this.setState((x) => ({
      passenger: {...x.passenger, ...p},
    }))
  }
}



// WEBPACK FOOTER //
// ./src/components/PassengerForm.tsx